"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationSendTypes = exports.UserNotificationTypes = exports.AdminNotificationTypes = void 0;
exports.AdminNotificationTypes = {
    tooLongMarketing: 'tooLongMarketing',
    readyForMarketing: 'readyForMarketing',
    contractNotSent: 'contractNotSent'
};
exports.UserNotificationTypes = {
    mediaMissing: 'mediaMissing',
    applicationTooLongInCreated: 'applicationTooLongInCreated',
    newApplications: 'newApplications'
};
exports.NotificationSendTypes = {
    email: 'email',
    sms: 'sms',
    web: 'web',
    all: 'all'
};
//# sourceMappingURL=notifications.js.map